import BaseModel from '@/shared/models/LandingPage'
import Reseller from './Reseller'

export default class LandingPage extends BaseModel {
    appends() {
        return ['resellers']
    }

    relationships() {
        return {
            resellers: new Reseller(),
        }
    }

    get actions() {
        return [
            {
                type: 'edit',
                to: {
                    name: 'landingPage.edit',
                    params: { id: this.id },
                },
            },
            { type: 'delete' },
        ]
    }
}
